import React from "react";
import "../common/common.scss";
import CloseIcon from "../../Assets/Icons/CloseIconSvg.svg";

const DetailsModal = ({
  handleClose,
  content,
  popupClassName,
  continueBtn,
  cancelBtn,
}) => {
  return (
    <div className="popup-container">
      <div
        className={`popup flex flex-col items-center bg-white rounded-[10px] drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] relative ${popupClassName}`}
      >
        <div className="h-[3%]">
          <img
            src={CloseIcon}
            alt="Close"
            className="absolute -top-6 -right-6 w-[35px] h-[35px] cursor-pointer"
            onClick={handleClose}
          />
        </div>
        <div className="text-[14px] sm:text-[16px] font-[400] font-montserrat text-[#303030] text-center break-words w-[95%]">
          {content}
        </div>
        {!cancelBtn ? (
          continueBtn
        ) : (
          <div className="w-full flex justify-center items-center gap-4">
            {cancelBtn}
            {continueBtn}
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailsModal;
